var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBotijaoP2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 31,
    viewBox: "0 0 24 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1356.651 -2179.677)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1356.704 2175.677)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.947 4)",
    fill: "#000FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 6.500057697296143 25.5002326965332 L 3.500017642974854 25.5002326965332 L 3.500017642974854 1.500002503395081 L 6.500057697296143 1.500002503395081 L 6.500057697296143 25.5002326965332 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5.000017642974854 2.999992370605469 L 5.000017642974854 24.00022315979004 L 5.000057697296143 24.00022315979004 L 5.000057697296143 2.999992370605469 L 5.000017642974854 2.999992370605469 M 3.000017642974854 -7.62939453125e-06 L 7.000057697296143 -7.62939453125e-06 C 7.552347660064697 -7.62939453125e-06 8.000057220458984 0.4477119445800781 8.000057220458984 0.9999923706054688 L 8.000057220458984 26.00022315979004 C 8.000057220458984 26.55251312255859 7.552347660064697 27.00022315979004 7.000057697296143 27.00022315979004 L 3.000017642974854 27.00022315979004 C 2.447727680206299 27.00022315979004 2.000018119812012 26.55251312255859 2.000018119812012 26.00022315979004 L 2.000018119812012 0.9999923706054688 C 2.000018119812012 0.4477119445800781 2.447727680206299 -7.62939453125e-06 3.000017642974854 -7.62939453125e-06 Z",
    stroke: "none",
    fill: "#000FFF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.053 6)",
    fill: "#000FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.8190860748291 25.14257621765137 L 5.312300205230713 24.75579833984375 L 5.305630207061768 24.75561904907227 L 5.298970222473145 24.75561904907227 C 2.249160051345825 24.75561904907227 0.5 23.02225875854492 0.5 20 L 0.5 5.999999046325684 C 0.5 2.967288970947266 2.967289924621582 0.499999076128006 6 0.499999076128006 L 18 0.499999076128006 C 21.0327091217041 0.499999076128006 23.5 2.967288970947266 23.5 5.999999046325684 L 23.5 20 C 23.5 21.73483848571777 23.24710083007812 22.97649955749512 22.72685050964355 23.79593849182129 C 22.15241813659668 24.70070648193359 21.20130348205566 25.14123344421387 19.8190860748291 25.14257621765137 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 6 1 C 3.242990493774414 1 1 3.242988586425781 1 6 L 1 20 C 1 22.7442798614502 2.526739120483398 24.25561904907227 5.298969268798828 24.25561904907227 L 5.312299728393555 24.25561904907227 L 5.325620651245117 24.25597953796387 L 19.82527542114258 24.64256477355957 C 21.41523170471191 24.63924026489258 22.00173759460449 24.00518417358398 22.30474090576172 23.52793884277344 C 22.77257919311523 22.79105949401855 23 21.63705825805664 23 20 L 23 6 C 23 3.242988586425781 20.75700950622559 1 18 1 L 6 1 M 6 0 L 18 0 C 21.3137092590332 0 24 2.686288833618164 24 6 L 24 20 C 24 23.3137092590332 23.12635040283203 25.642578125 19.81264114379883 25.642578125 L 5.298969268798828 25.25561904907227 C 1.985269546508789 25.25561904907227 0 23.3137092590332 0 20 L 0 6 C 0 2.686288833618164 2.686290740966797 0 6 0 Z",
    stroke: "none",
    fill: "#000FFF"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.053 30)",
    fill: "#000FFF",
    stroke: "#000FFF",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 5,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 4,
    rx: 1.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H17.073",
    transform: "translate(1360.296 2196.476)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotijaoP2);
export default __webpack_public_path__ + "static/media/botijao-p2.cae2d924c134be6e57b2062cb280c320.svg";
export { ForwardRef as ReactComponent };